import { getPromoMessaging } from "../../utils/product/getPromoMessaging";
import styles from "./PromotionalMessages.module.scss";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";
import { PromotionalMessageItem } from "./PromotionalMessageItem";

type Props = {
  /**
   * An array of Message objects.
   */
  promotionalMessages: (PromotionalMessage | NonPromotionalMessage)[];
  /**
   * Flag to determine if product in countdown test is available to order.
   */
  countdownTimerAvailabileToOrder: boolean;
  /**
   * Flag to determine whether to display messages in black for Dior.
   */
  isBlackOverride: boolean;
  /**
   * Flag to determine whether to display price promise override.
   */
  isPricePromise: boolean;
  /**
   * Flag to determine whether to display new typography.
   */
  isNewTypographyEnabled: boolean;
};

const MAX_PROMO_MESSAGES = 2;

export const PromotionalMessagesUI = ({
  promotionalMessages,
  countdownTimerAvailabileToOrder,
  isBlackOverride = false,
  isPricePromise = false,
  isNewTypographyEnabled,
}: Props) => {
  const { pageMessages } = getPromoMessaging(promotionalMessages);

  if (pageMessages.length === 0) return null;

  return (
    <div
      data-testid="product:promotional-messages"
      className={styles.promotionalMessagesWrapper}
      data-component="PromotionalMessages"
    >
      {pageMessages
        .slice(0, MAX_PROMO_MESSAGES)
        .map((message: PromotionalMessage | NonPromotionalMessage, idx) => {
          return (
            <PromotionalMessageItem
              message={message}
              key={idx}
              countdownTimerAvailabileToOrder={countdownTimerAvailabileToOrder}
              isBlackOverride={isBlackOverride}
              isPricePromise={isPricePromise}
              isNewTypographyEnabled={isNewTypographyEnabled}
            />
          );
        })}
    </div>
  );
};
